import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from "app/shared/components/sidebar/sidebar.component";
import { NavbarComponent } from "app/shared/components/navbar/navbar.component";
import { ResetScrollOnNavigateDirective } from 'app/shared/directives/reset-scroll/reset-scroll-on-navigate.directive';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [SidebarComponent, RouterOutlet, NavbarComponent, ResetScrollOnNavigateDirective],
  templateUrl: './main-layout.component.html',
})
export class MainLayoutComponent {}
